export default __webpack_public_path__ + "static/media/048-lion.c6724aeb.svg";